import { render, staticRenderFns } from "./Display-Cardapio.vue?vue&type=template&id=17d322e8&"
import script from "./Display-Cardapio.vue?vue&type=script&lang=js&"
export * from "./Display-Cardapio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Display-Cardapio.vue"
export default component.exports